import { CHANGE_LIST_PARAMS } from '@/state/types/list'

export const changeListParams = (resource, params) => {
  return {
    type: CHANGE_LIST_PARAMS,
    payload: params,
    meta: { resource },
  }
}



// WEBPACK FOOTER //
// ./state/actions/list.js